import { cn } from '@/lib/utils';

type CardContentProps = React.ComponentProps<'div'>;

export const CardContent = ({ className, ...props }: CardContentProps) => (
  <div
    data-slot="card-content"
    className={cn('tw-px-4 group-data-[size=sm]/card:tw-px-3', className)}
    {...props}
  />
);
